import t from "./ghl-ui.es741.js";
import o from "./ghl-ui.es406.js";
import p from "./ghl-ui.es1302.js";
import e from "./ghl-ui.es419.js";
function n(r, a) {
  var m = e(r) ? t : p;
  return m(r, o(a));
}
export {
  n as default
};
